import config from '../../config';

import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

import FooterButton from '../../components/common/FooterButton';
import OtpInput from '../../components/home/OtpInput';
import Modal from '../common/Modal';
import { FadeInTransition } from '../../components/transitions/transitions';
import Lottie from 'react-lottie';

import unbrellaJar from '../../images/common/umbrella-jar.svg';
import backButton from '../../images/common/back-button-white.svg';
import { ReactComponent as InfoIcon } from '../../images/common/info-dynamic-color.svg';
import swirls from '../../images/common/bg-swirls.svg';
import folder from '../../images/common/folder-orange.svg';
import emailCheckIcon from '../../images/common/email-check.svg';
import otpback from '../../images/home/otpback.svg';
import verificationIcon from '../../images/home/verificationIcon.svg';
import { setTimeoutVerification, showError } from '../../actions';

import successLottie from '../../images/common/success(4).json';

import {
  resetLinkedBenefitsData,
  updateLoginState,
  setResponseDataVerifyOtp,
} from '../../actions';
import { initializeChatClient } from '../../services/chatClient';
import { linkBenefit, verifyOtp } from '../../services/switch-benefit';

const BodyContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, ${(props) => props.bgColor}, #312652);
  width: 100svw;
`;

const Label = styled.p`
  color: var(--Primary-Text-New, #0f0b28);
  font-feature-settings: 'liga' off, 'clig' off;

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  margin-bottom: 8px;
`;

const TextInput = styled.input`
  font-family: , sans-serif;
  font-weight: 500;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #d2d3dd;
  font-feature-settings: 'liga' off, 'clig' off;

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  margin-bottom: 12px;

  &:focus {
    outline: none;
    border-color: ${(props) => props.border};
  }
`;

const ModalBoundary = styled.div`
  width: 100vw;
  max-width: 440px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;

const Message = styled.p`
  left: 8.75%;
  right: 8.75%;
  top: calc(50% - 16px / 2 + 2px);
  font-family: , sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;
`;

const Title = styled.div`
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 26px;
  color: white;
`;

const Title2 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #131836;
  margin-top: 24px;
  margin-bottom: 32px;
`;

const Title3 = styled.p`
  color: var(--Text-Primary, #0f0b28);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

const Title4 = styled.p`
  color: ${(props) => props.color};
  text-align: center;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
`;

const Text = styled.p`
  color: #585969;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
`;

const Text2 = styled.p`
  color: var(--Text-Sub, #767787);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 16.8px */
`;

const Button = styled.div`
  height: 42px;
  width: 80%;
  border-radius: 12px;
  background: ${(props) => (!props.disabled ? props.bg : '#e3e3e3')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  cursor: pointer;
  background: #714fff;
`;

const TryAgainBtn = styled.div`
  height: 42px;
  width: 80%;
  border-radius: 12px;
  // background: ${(props) => (!props.disabled ? props.bg : '#e3e3e3')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  cursor: pointer;
  border: 1px solid #714fff;
  color: #714fff;
  background: #ffffff;
`;

const TryAgainText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  width: 66px;
  height: 20px;
`;

const ButtonOrange = styled.div`
  width: 100%;
  border-radius: 12px;
  display: flex;
  justify-content: ${(props) =>
    props.leftSideButtonText ? 'space-between' : 'center'};
  padding: 16px 32px;
  margin-top: 12px;
  cursor: pointer;
  border: ${(props) => (props.border ? '1px solid #ED8266' : 'none')};
`;

const ButtonText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
`;
const OtpVerificationModal = styled.div`
  height: 100vh;
  width: 100vw;
  max-width: 440px;
  // width: 100svw;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`;

const TopButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 440px;
  align-items: center;
  height: 32;
  margin-top: 59px;
  margin-left: 36px;
  margin-right: 36px;
  justify-content: space-between;
`;

const OtpBackButton = styled.img`
  width: 32px;
  height: 32px;
`;

const SkipButton = styled.div`
  width: 34px;
  height: 19px;

  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;
  color: #714fff;
`;

const VerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const VerificationIcon = styled.img`
  width: 183px;
  height: 181px;
  margin-top: 115px;
  align-self: center;

  @media (max-height: 720px) {
    margin-top: 20px;
  }
`;

const VerificationInfo = styled.div`
  margin: 40px 20px 0 20px;
  // width: 341px;
  // height: 116;
  // top: 328px;
  // left: 17px;
`;

const VerificationTitle = styled.div`
  // width: 341;
  height: 36px;

  font-weight: bold;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #0f0b28;
`;

const VerificationInfoTextArea = styled.div`
  // width: 339;
  height: 72px;
  // top: 44px;
  // left: 1px;

  font-weight: regular;
  font-size: 16;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  margin: 20px 0;
`;

const VerificationEmail = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
`;

const VerifyOtpContainer = styled.div`
  // width: 150px;
  padding: 0 40px;
  self-align: center;

  // height: 295.0000000000003;
  // top: 627px;
  // left: 40px;
  // angle: 90 deg;
  margin: 0 20px;
  gap: 20px;
`;

const SuccessModal = styled.div`
  height: 319px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  gap: 10px;
  padding: 0 16px 16px 16px;
  background: #ffffff;
  box-shadow: 0px 0px 15.53px 0px #0000000d;
`;

const SuccessMessage = styled.div`
  width: 295px;
  height: 58px;

  font-weight: 700;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  color: #0f0b28;
`;

const SuccessModalButton = styled.div`
  margin-top: 20px;
  width: 295px;
  height: 41px;
  border-radius: 12px;
  justify-content: space-between;
  padding-top: 12px;
  padding-right: 8px;
  padding-bottom: 12px;
  padding-left: 8px;
  background: #714fff;
`;

const ErrorMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  align-items: center;
  margin: 10px;
  color: #ff754c;
`;

const EditEmail = styled.div`
  color: #714fff;
`;

const botChannel = (userId) => `visit.bot.${userId}`;

const LinkNewBenefit = ({ history }) => {
  const user = useSelector((state) => state.user);
  const { linkedBenefitsData } = useSelector((state) => state.linkBenefits);
  const { authToken } = user;

  const dispatch = useDispatch();

  const chatClientRef = useRef(null);

  const inputRef = useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSignUp = searchParams.get('isSignUp') === 'true' ? true : false;

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [screen, setScreen] = useState('');
  const [responseData, setResponseData] = useState();
  // const [timeoutInSeconds, setTimeoutInSeconds] = useState(60);
  const [showEmailSentModal, setShowEmailSentModal] = useState(false);
  const [bgColor, setBgColor] = useState('#8A73EA');
  const [otp, setOtp] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [showSkipButton, setShowSkipButton] = useState(false);
  const [backButtonState, setBackButtonState] = useState(
    history?.location?.state?.backButtonState
  );

  const timeoutInSeconds = useSelector(
    (state) => state.linkBenefits.timeoutInSeconds
  );

  const responseDataRedux = useSelector(
    (state) => state.linkBenefits.responseData
  );

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: successLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const shadowStyle = { boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)' };

  const sendVerificationOtp = async () => {
    try {
      const response = await linkBenefit(authToken, email, isSignUp);

      if (response?.data?.screenType === 'ssoLoginNeeded') {
        // setShowSuccessModal(true);
        console.log('SSO Login Needed', response?.data?.screenType);
        window.location.href = response?.data?.ssoLoginUrl;

        // setTimeout(() => {
        //   window.location.href = response?.data?.ssoLoginUrl;
        // }, 2000);
      }

      if (
        response?.data?.errorMessage &&
        response?.data?.message === 'success'
      ) {
        // Handle error case
        setScreen(response.data.screenType);
        console.log('error');
        setResponseData(response.data);
        // }
      } else if (
        !response?.data?.errorMessage &&
        response?.data?.message === 'success'
      ) {
        // Handle success case
        console.log('success');
        // setTimeoutInSeconds(response?.data?.otpConfig?.retryCooldown);
        const cooldown = response?.data?.otpConfig?.retryCooldown;
        if (cooldown > 0) {
          dispatch({ type: 'SET_TIMEOUT_VERIFICATION', payload: cooldown });
        }
        // dispatch(
        //   setTimeoutVerification(response?.data?.otpConfig?.retryCooldown)
        // );
        setShowSkipButton(response?.data?.otpConfig?.skipAllowed);

        setScreen('');
        // setResponseData(response.data);
        dispatch(setResponseDataVerifyOtp(response.data)); // ✅ store in Redux
        setShowEmailSentModal(true);
        setBackButtonState('linkNewBenefit');
        inputRef.current?.focus();
      } else {
        // Handle unsuccessful verification but valid response
        // dispatch(showError(response?.data?.errorMessage));
        console.log(response?.data?.errorMessage);
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      // dispatch(showError(error?.response?.data?.errorMessage));
      // You could reset the OTP input here if needed
      setOtp('');
    }
  };

  useEffect(() => {
    // Check if navigation state contains the flag
    if (location?.state?.showEmailSentModal) {
      setShowEmailSentModal(true);
    }
  }, [location.state]);

  const resendVerificationOtp = async () => {
    try {
      const response = await linkBenefit(
        authToken,
        responseDataRedux?.email,
        isSignUp
      );

      const data = response?.data;

      if (data?.errorMessage && data?.message === 'success') {
        setScreen(data.screenType);
        setResponseData(data);
        setOtpError(data.errorMessage);
      } else if (!data?.errorMessage && data?.message === 'success') {
        console.log('success');

        const cooldown = data?.otpConfig?.retryCooldown;

        if (cooldown > 0) {
          dispatch({ type: 'SET_TIMEOUT_VERIFICATION', payload: cooldown });
        }

        setShowEmailSentModal(true);
        setScreen('');
        setResponseData(data);
        inputRef.current?.focus();
        setOtpError('');
      } else {
        setOtpError('');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      dispatch(showError(error?.response?.data?.errorMessage));
      setOtp('');
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const verifyOtpResponse = await verifyOtp(
        authToken,
        email ? email : responseDataRedux?.email,
        Number(otp)
      );

      if (
        !verifyOtpResponse.data?.errorMessage &&
        verifyOtpResponse?.data?.message === 'success'
      ) {
        setShowSuccessModal(true);

        setTimeout(() => {
          if (
            verifyOtpResponse?.data?.screenType === 'LINKING_SUCCESS_SIGNUP'
          ) {
            handleSignUp();
          } else {
            // setScreen(verifyOtpResponse?.data?.screenType);
            history.push('/home');
          }

          // if (isSignUp) {
          //   handleSignUp();
          // } else {
          //   if (responseData) {
          //     dispatch(setResponseDataVerifyOtp(responseData)); // ✅ store in Redux
          //     history.push('/home', { responseData });
          //   } else {
          //     history.push('/home'); // 👈 no need to pass it in history now
          //   }
          // }
        }, 2000);
      } else {
        // Handle unsuccessful verification but valid response
        // dispatch(showError(verifyOtpResponse?.data?.errorMessage));
        setOtpError(verifyOtpResponse?.data?.errorMessage);
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      dispatch(showError(error?.response?.data?.errorMessage));
      // You could reset the OTP input here if needed
      setOtp('');
    }
  };

  const handleInputChange = (e) => {
    if (responseData) {
      handleTryAgain();
    }
    setEmail(e.target.value);
  };

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  };

  const handleMessage = () => {
    setMessage('We will send an OTP to this email address.');
  };

  const handleSignUp = () => {
    dispatch(updateLoginState('ONE_LAST_STEP'));
    history.push('/one-last-step');
  };

  const handleSupport = () => {
    window.location.href = 'mailto:hello@getvisitapp.com';
  };

  const handleBack = () => {
    if (isSignUp) {
      if (screen === 'EMAIL_SENT' || screen === 'LINKING_SUCCESS') {
        dispatch(updateLoginState('ONE_LAST_STEP'));
        history.push('/one-last-step');
      } else {
        history.push('/select-user');
      }
    } else {
      history.push('/home');
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const formatDescription = (description) => {
    const regex = /\{(.*?)\}/;
    const match = description.match(regex);

    if (!match) return description;

    const [fullMatch, boldText] = match;
    const [before, after] = description.split(fullMatch);

    return (
      <span>
        {before}
        <strong>{boldText}</strong>
        {after}
      </span>
    );
  };

  const handleTryAgain = () => {
    handleMessage();
    setEmail('');
    setScreen('');
    setResponseData(null);
    // setTimeoutInSeconds(timeoutInSeconds);
    dispatch({ type: 'SET_TIMEOUT_VERIFICATION', payload: 60 }); // or whatever the default retryCooldown is
    setShowEmailSentModal(false);
    setBgColor('#8A73EA');
  };

  const handleResendOtp = () => {
    console.log('Resending OTP to:', email);
    // TODO: Trigger OTP resend logic
  };

  useEffect(() => {
    let isMounted = true;

    async function setupChat() {
      try {
        const client = await initializeChatClient(user.userUUID, 'bot');
        if (isMounted) {
          chatClientRef.current = client;

          if (typeof client.subscribe === 'function') {
            console.log('Subscribing to:', botChannel(user.userId));
            client.subscribe(botChannel(user.userId));
          } else {
            console.error(
              'Chat client does not have a subscribe method:',
              client
            );
          }
        }
      } catch (error) {
        console.error('Error initializing chat client:', error);
      }
    }

    setupChat();

    return () => {
      isMounted = false;

      if (chatClientRef.current) {
        chatClientRef.current.unsubscribe(botChannel(user.userId));
        chatClientRef.current = null;
      }

      dispatch(resetLinkedBenefitsData());
    };
  }, [user.userId, dispatch]);

  useEffect(handleMessage, [email]);

  useEffect(() => {
    if (screen === 'EMAIL_SENT') {
      // setTimeoutInSeconds(60);
      setShowEmailSentModal(true);
    } else if (screen === 'NO_INFO_FOUND' || screen === 'DUPLICATE_EMAIL') {
      setBgColor(isSignUp ? '#8A73EA' : '#ED8266');
    } else if (screen === 'ssoLoginNeeded') {
      const tempEmail = email;
      handleTryAgain();
      setEmail(tempEmail);
    } else if (screen === 'LINKING_SUCCESS') {
      setTimeout(() => history.push('/home'), 3000);
    } else if (screen === 'LINKING_SUCCESS_SIGNUP') {
      dispatch(updateLoginState('ONE_LAST_STEP'));
      history.push('/one-last-step');
    }
  }, [screen]);

  useEffect(() => {
    if (linkedBenefitsData) {
      setShowEmailSentModal(false);
      // setTimeoutInSeconds(0);
      setResponseData({
        data: linkedBenefitsData,
      });
      setScreen('LINKING_SUCCESS');
    }
  }, [linkedBenefitsData]);

  useEffect(() => {
    return () => {
      if (chatClientRef.current) {
        chatClientRef.current.unsubscribe(botChannel(user.userId));
        chatClientRef.current = null;
      }
      dispatch(resetLinkedBenefitsData());
    };
  }, []);

  useEffect(() => {
    if (showSuccessModal) {
      // Optional: delay a bit after showing the modal, or wait for modal to close
      const timer = setTimeout(() => {
        if (screen === 'LINKING_SUCCESS') {
          history.push('/home');
        } else if (screen === 'LINKING_SUCCESS_SIGNUP') {
          handleSignUp();
        }
      }, 2000); // delay after modal is shown

      return () => clearTimeout(timer); // clean up
    }
  }, [showSuccessModal]);

  useEffect(() => {
    let timer;
    if (showSuccessModal) {
      timer = setTimeout(() => {
        setShowSuccessModal(false);
        if (screen === 'LINKING_SUCCESS') {
          history.push('/home');
        } else if (screen === 'LINKING_SUCCESS_SIGNUP') {
          handleSignUp();
        }
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [showSuccessModal, screen, history]);

  return (
    <BodyContainer bgColor={bgColor}>
      <div
        style={{ paddingTop: '3rem' }}
        className={`flex w-full p-4 justify-around ${
          bgColor === '#ED8266' && 'mix-blend-luminosity'
        }`}
      >
        <div className="flex flex-col justify-between py-4 ">
          <img
            src={backButton}
            alt="Back"
            width={46}
            onClick={handleBack}
            style={{ marginLeft: '-16px' }}
          />
          <Title>Corporate Benefits</Title>
        </div>
        <div>
          <img src={unbrellaJar} alt="umbrella-jar" width={200} />
        </div>
      </div>
      <ModalBoundary>
        <>
          <div className="flex flex-col w-full box-border px-6">
            <Title2>Enter your Corporate Email ID</Title2>
            <Label>Email address</Label>
            <TextInput
              ref={inputRef}
              autoFocus
              border={
                screen !== 'EMAIL_SENT' && responseData ? '#FF4C4C' : '#714fff'
              }
              type="email"
              value={email}
              placeholder="Enter Your Email ID"
              onChange={handleInputChange}
            />
            <div className="flex items-start gap-2">
              <InfoIcon
                className={`flex-shrink-0 
                            ${
                              screen !== 'EMAIL_SENT' && responseData
                                ? 'text-accent2-shades7'
                                : 'text-secondary-shades6'
                            }
                        `}
                width={16}
                height={16}
              />
              <Message
                className={
                  screen !== 'EMAIL_SENT' && responseData
                    ? 'text-accent2-shades7'
                    : 'text-secondary-shades6'
                }
              >
                {['', 'EMAIL_SENT'].includes(screen)
                  ? message
                  : formatDescription(responseData?.description)}
              </Message>
            </div>
          </div>
        </>

        {!isSignUp && screen === 'NO_INFO_FOUND' ? (
          <div className="w-full pb-4 absolute bottom-0">
            <ButtonOrange onClick={handleSupport} border={false}>
              <ButtonText style={{ color: '#ED8266' }}>
                Contact Support
              </ButtonText>
            </ButtonOrange>
            <div style={shadowStyle} className="w-full flex gap-4 px-4 pt-2">
              <TryAgainBtn onClick={handleTryAgain}>
                <TryAgainText>Try Again</TryAgainText>
              </TryAgainBtn>
              <Button onClick={handleSignUp} bg="var(--primary-button)">
                <ButtonText color="#fff">Sign Up</ButtonText>
              </Button>
            </div>
          </div>
        ) : isSignUp &&
          screen === 'GENERIC_EMAIL_ERROR' &&
          responseData.contactSupport ? (
          <div className="w-full pb-4 absolute bottom-0">
            <ButtonOrange onClick={handleSupport} border={false}>
              <ButtonText style={{ color: '#ED8266' }}>
                Contact Support
              </ButtonText>
            </ButtonOrange>
            <div style={shadowStyle} className="w-full flex gap-4 px-4 pt-2">
              <Button bg="#fff" onClick={handleTryAgain}>
                <ButtonText color="var(--primary-button)">Try Again</ButtonText>
              </Button>
              <Button onClick={handleSignUp} bg="var(--primary-button)">
                <ButtonText color="#fff">Sign Up</ButtonText>
              </Button>
            </div>
          </div>
        ) : !isSignUp && screen === 'DUPLICATE_EMAIL' ? (
          <div
            style={shadowStyle}
            className="flex w-full p-4 pb-6 absolute bottom-0"
          >
            <ButtonOrange onClick={handleSupport} border={true}>
              <ButtonText style={{ color: '#ED8266' }}>
                Contact Support
              </ButtonText>
            </ButtonOrange>
          </div>
        ) : isSignUp && screen === 'DUPLICATE_EMAIL' ? (
          <div
            style={shadowStyle}
            className="flex w-full p-4 pb-6 absolute bottom-0"
          >
            <ButtonOrange onClick={handleSupport} border={true}>
              <ButtonText style={{ color: '#ED8266' }}>
                Contact Support
              </ButtonText>
            </ButtonOrange>
          </div>
        ) : screen !== 'LINKING_SUCCESS' ? (
          <FooterButton
            shadowStyle={shadowStyle}
            disabled={!validateEmail(email)}
            onClick={sendVerificationOtp}
            buttonText={'Send OTP'}
          />
        ) : (
          <></>
        )}
      </ModalBoundary>
      {showEmailSentModal && (
        <Modal>
          <OtpVerificationModal>
            <TopButtonContainer>
              <OtpBackButton
                src={otpback}
                onClick={() => {
                  console.log('backButtonState', backButtonState);
                  if (backButtonState === 'home') {
                    history.goBack();
                    // setBackButtonState('');
                  } else if (backButtonState === 'linkNewBenefit') {
                    setShowEmailSentModal(false);
                  }
                }}
              />
              {showSkipButton && (
                <SkipButton
                  onClick={() => {
                    if (isSignUp) {
                      handleSignUp();
                    } else {
                      if (responseData) {
                        dispatch(setResponseDataVerifyOtp(responseData)); // ✅ store in Redux
                        history.push('/home', { responseData });
                      } else {
                        history.push('/home'); // 👈 no need to pass it in history now
                      }
                    }
                  }}
                >
                  Skip
                </SkipButton>
              )}
            </TopButtonContainer>
            <VerificationContainer>
              <VerificationIcon src={verificationIcon} />
              <VerificationInfo>
                <VerificationTitle>Verification</VerificationTitle>
                <VerificationInfoTextArea>
                  {responseDataRedux?.description}
                  <VerificationEmail>
                    {responseDataRedux?.email}
                    {'  '}
                    <span
                      onClick={() => {
                        setBackButtonState('linkNewBenefit');
                        setShowEmailSentModal(false);
                      }}
                      style={{
                        color: '#714FFF',
                      }}
                    >
                      Edit
                    </span>
                  </VerificationEmail>
                </VerificationInfoTextArea>
              </VerificationInfo>
              <VerifyOtpContainer>
                <OtpInput
                  onChange={(value) => {
                    setOtp(value);
                    console.log('OTP value:', value);
                  }}
                />
                {otpError && (
                  <ErrorMessage>
                    <InfoIcon
                      className={`flex-shrink-0 `}
                      width={16}
                      height={16}
                    />
                    <Message>{otpError}</Message>
                  </ErrorMessage>
                )}
              </VerifyOtpContainer>
              <Button onClick={handleVerifyOtp}>
                <ButtonText>Verify OTP</ButtonText>
              </Button>
              <Text>
                {' '}
                <span className="text-primary">
                  {formatTime(timeoutInSeconds)}{' '}
                </span>{' '}
                Didn't receive the code?{' '}
                <span
                  className={`${
                    timeoutInSeconds > 0 ? 'text-gray-400' : 'text-primary'
                  }`}
                  style={{
                    cursor: timeoutInSeconds > 0 ? 'not-allowed' : 'pointer',
                    opacity: timeoutInSeconds > 0 ? 0.4 : 1,
                  }}
                  onClick={
                    timeoutInSeconds > 0
                      ? null
                      : () => {
                          resendVerificationOtp();
                          // setTimeoutInSeconds(timeoutInSeconds);
                          formatTime(timeoutInSeconds);
                        }
                  }
                >
                  Resend{' '}
                </span>{' '}
              </Text>
            </VerificationContainer>
          </OtpVerificationModal>
        </Modal>
      )}
      {showSuccessModal && (
        <Modal>
          <div className="modalContainer">
            <SuccessModal>
              <Lottie
                options={defaultOptions}
                speed={0.8}
                width={148}
                height={148}
              />
              <SuccessMessage>Email Verification Complete</SuccessMessage>
              <SuccessModalButton>
                <ButtonText
                  onClick={() => {
                    if (screen === 'LINKING_SUCCESS') {
                      history.push('/home');
                    } else if (screen === 'LINKING_SUCCESS_SIGNUP') {
                      handleSignUp();
                    }
                  }}
                >
                  Okay!
                </ButtonText>
              </SuccessModalButton>
            </SuccessModal>
          </div>
        </Modal>
      )}
    </BodyContainer>
  );
};

export default LinkNewBenefit;
